module.exports = __webpack_public_path__ + "img/gold-vip.3b7f3bb8.svg";